export default __webpack_public_path__ + "static/media/femiMed_Badanie_1_Trymestr.2b97fa1b.webp";